var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAreaSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1222 12.2094L11.2383 13.0933L10.6463 12.5013L11.5302 11.6174L9.91259 9.99987L9.02876 10.8837L8.43676 10.2917L9.32059 9.40787L7.70301 7.79029L6.81918 8.67412L6.22718 8.08212L7.11101 7.19829L5.4851 5.57238L4.60127 6.45621L4.00927 5.86421L4.8931 4.98038L3.27552 3.3628L2.39169 4.24663L1.79969 3.65463L2.68352 2.7708L0.732422 0.819702V12.4929C0.732422 13.4101 1.48284 14.1605 2.40003 14.1605H14.0733L12.1222 12.2094ZM3.23383 11.6591V6.85643L8.03654 11.6591H3.23383Z",
    fill: "#757575"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaSize);
export default __webpack_public_path__ + "static/media/areaSize.4c4796d9a29f479b7c23cf4c3e8d2d53.svg";
export { ForwardRef as ReactComponent };